import React from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export default function ConfirmDialog({ open, onOpenChange, title = "Confirm action", description, confirmLabel = "Confirm", cancelLabel = "Cancel", variant = "default", onConfirm, testid = "confirm" }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={`${testid}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-head uppercase tracking-tight">{title}</AlertDialogTitle>
          {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testid}-cancel`}>{cancelLabel}</AlertDialogCancel>
          <AlertDialogAction data-testid={`${testid}-ok`} onClick={onConfirm}
            className={variant === "destructive" ? "bg-[#FF3B30] text-white hover:bg-[#FF5000]" : "bg-black text-white hover:bg-[#FF5000]"}>
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
